import {PAGE_CREATE} from '../constant/eventbus'
import {get_act_stat} from '../api'
import isUndefined from 'lodash/isUndefined'
import {error_event} from '../tools/mgtv/analysis'
import {setShare} from '../tools/mgtv/share'
import setTitle from '../tools/set-title'

export default {
  install: function (EventBus) {
    EventBus.$on(PAGE_CREATE, () => {
      //获取活动状态
      get_act_stat().then(res => {
        if (!res) {
          window.$dialog.alert({message: `活动状态获取失败，请刷新重试！`}).then(() => {
            window.location.reload();
          });
          return;
        }
        if (res.ret === 0 && !isUndefined(res.data.is_start)) {
          const is_start = res.data.is_start;
          EventBus.$set(EventBus.act, 'act_stat', is_start);
          if (is_start === 2) {
            window.$toast("活动已结束");
          } else if (is_start === 0) {
            window.$toast("活动即将开始,敬请期待");
          }
          window.rootdata = window.rootdata || {};
          window.rootdata.act_name_chn = res.data.act_name_chn;
          window.$bus.ext = res.data.ext;

          //删除 在获取ZPINFO时设置
          //const ext = res.data.ext;
          // if (ext.title) {
          //   setTitle(ext.title)
          // }

          //在详情中设置分享文案，这里删除
          // if(ext.share_title){
          //   setShare({
          //     title:ext.share_title,
          //     desc:ext.share_desc,
          //     img:ext.share_img,
          //   })
          // }

        } else {
          window.$toast('获取活动状态失败');
        }
      })
      //   .catch(e => {
      //   window.$toast('获取活动状态失败');
      //   error_event(e, "EventAct")
      // })
    });


  }
}





// WEBPACK FOOTER //
// ./src/EventBus/EventAct.js